module.exports = __webpack_public_path__ + "static/media/OurStoryImage.2bc2cc4a.png";